import ApiService from '@/services/core/api.service'

const AdminBookingService = {
  async get (query) {
    return ApiService.get(`admin/bookings?${query}`)
  },

  async put (payload) {
    return ApiService.put(`admin/bookings/${payload.id}`, payload)
  },

  async post (payload) {
    return ApiService.post('admin/bookings', payload)
  }
}

export default AdminBookingService
